module.exports = __webpack_public_path__ + "static/flappy-bird-04f5ba46d062b72b6a4da5f6b6e81cee.mp4";